import dayjs from 'dayjs';

export function calcEstimatedCSVRows(startDate: Date, endDate: Date, sans: number): number {
    const ROWS_IN_DAY = 96; // for 15 min intervals

    const daysDiff = dayjs(endDate).diff(dayjs(startDate), 'days');

    if (daysDiff < 1) return 0;

    return sans * daysDiff * ROWS_IN_DAY;
}
